module.exports = __webpack_public_path__ + "static/media/webvision7.6850bcfe.png";